import {
  CREATE_PROOF_OF_PERFORMANCE_REPORT,
  DELETE_PROOF_OF_PERFORMANCE_REPORT,
  EDIT_PROOF_OF_PERFORMANCE_REPORT,
  RECEIVE_PROOF_OF_PERFORMANCE_REPORTS,
  REQUEST_PROOF_OF_PERFORMANCE_REPORT,
  REQUEST_SITE_PROOF_OF_PERFORMANCE_REPORT,
} from '@sophocles/entities/ProofOfPerformanceReport/proofOfPerformanceReportActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_PROOF_OF_PERFORMANCE_REPORTS: // Read
      return state.merge(action.proofOfPerformanceReports);
    case DELETE_PROOF_OF_PERFORMANCE_REPORT: // Delete
      return state.delete(action.proofOfPerformanceReports);
    case EDIT_PROOF_OF_PERFORMANCE_REPORT: // Update
    case CREATE_PROOF_OF_PERFORMANCE_REPORT: // Create
    case REQUEST_PROOF_OF_PERFORMANCE_REPORT:
    default:
      return state;
  }
}

export function proofOfPerformanceReportReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_PROOF_OF_PERFORMANCE_REPORT:
    case DELETE_PROOF_OF_PERFORMANCE_REPORT:
    case RECEIVE_PROOF_OF_PERFORMANCE_REPORTS:
    case EDIT_PROOF_OF_PERFORMANCE_REPORT:
    case REQUEST_PROOF_OF_PERFORMANCE_REPORT:
    case REQUEST_SITE_PROOF_OF_PERFORMANCE_REPORT:
      return getState(state, action);
    default:
      return state;
  }
}
